<template>
	<span>
		<b-row>
			<b-col lg="6">
				<base-button
					@click="reloadButtonClick()"
					type="primary"
					size="sm"
					class="text-white mt-2 w-100 text-left"
				>
					General
				</base-button>
				<b-row class="mt-3">
					<b-col lg="3">
						<label for="parent" class="mt-1">Parent</label>
					</b-col>
					<b-col lg="9">
						<b-form-select
						size="sm"
						v-model="carrierUpdate.parent"
						:options="parentOption"
						:state="parentState"
						>
						</b-form-select>
					</b-col>
				</b-row>
				<b-row class="mt-2">
					<b-col lg="3">
						<label for="name" class="mt-1">Display Name</label>
					</b-col>
					<b-col lg="9">
						<b-form-group>
							<b-form-input
								size="sm"
								v-model="carrierUpdate.display_name"
								:state="displayNameState"
								:disabled="carrierUpdate.name !== ''"
								placeholder="Enter your name"
							></b-form-input>
							<b-form-invalid-feedback :state="displayNameState">
								Please enter a valid display name
							</b-form-invalid-feedback>
						</b-form-group>
					</b-col>
				</b-row>
        <b-row>
					<b-col lg="3">
						<label for="name" class="mt-1">MCCMNC</label>
					</b-col>
					<b-col lg="9">
						<b-form-group>
							<b-form-input
								size="sm"
								v-model="carrierUpdate.mccmnc"
								:state="mccMncState"
								placeholder="Enter Carrier MCCMNC"
							></b-form-input>
							<!-- <b-form-invalid-feedback :state="displayNameState">
								Please enter a valid display name
							</b-form-invalid-feedback> -->
						</b-form-group>
					</b-col>
				</b-row>
			</b-col>
			<b-col lg="6">
				<base-button type="primary" size="sm" class="text-white mt-2 w-100 text-left"> Settings </base-button>
				<b-row class="mt-3">
					<b-col lg="4">
						<b-form-checkbox size="sm" class="ml-2" v-model="carrierUpdate.flags.httpota">
							SMS push for HTTP Poll
						</b-form-checkbox>
					</b-col>
					<b-col lg="4">
						<b-form-checkbox size="sm" class="ml-2" v-model="carrierUpdate.flags.smsota">
							Allow SMS OTA
						</b-form-checkbox>
					</b-col>
					<b-col lg="4">
						<b-form-checkbox size="sm" class="ml-2" v-model="carrierUpdate.flags.force_smsota">
							Force SMS OTA
						</b-form-checkbox>
					</b-col>
				</b-row>
				<b-row class="mt-3">
					<b-col cols="auto">
						<label for="parent" class="mt-1">Technology</label>
					</b-col>
					<b-col lg="3">
						<b-form-select
							size="sm"
							v-model="carrierUpdate.technology"
							:options="technologyOption"
							:state="technologyState"
						></b-form-select>
					</b-col>
					<b-col cols="auto">
						<label for="vendor" class="mt-1">SIM Vendor</label>
					</b-col>
					<b-col lg="3">
						<b-form-select
						size="sm"
						v-model="carrierUpdate.vendor"
						:options="vendorOption"
						:state="vendorState"
						></b-form-select>
					</b-col>
				</b-row>
			</b-col>
		</b-row>
		<b-row class="mt-2">
			<b-col cols="9"></b-col>
			<b-col>
				<base-button
					type="primary"
					size="sm"
					class="w-100 text-center text-white"
					v-on:click="saveSettings(carrier)"
					:disabled="!submitDisabled"
				>
					<b-icon icon="check" class="font-16"></b-icon>
					Save
				</base-button>
			</b-col>
		</b-row>
	</span>
</template>

<script>
import otaDashboardService from "../../../../common/api-services/ota-dashboard-service";
import Toast from "../../../Components/Toast.vue";

export default {
	name: "CarrierSettings",
	props: {
		carrier: {
			type: Object,
			required: true,
		},
		parentOption: {
			type: Array,
			required: true,
		},
		vendorOption: {
			type: Array,
			required: true,
		},
		technologyOption: {
			type: Array,
			required: true,
		},
	},
	mounted() {
		// console.log(this.carrier);
		this.carrierUpdate = {...this.carrier, mccmnc: ""};
	},
  watch: {
    vendorOption: function (newVal, oldVal) {
      if (newVal.length > 0) {
        // console.log(newVal);
        // console.log(this.carrierUpdate.vendor);
        if (this.carrierUpdate.vendor === "none" || this.carrierUpdate.vendor === "") {
          this.carrierUpdate.vendor = newVal[0].value;
        }
      }
    },
  },
	data() {
		return {
			carrierUpdate: {
				parent: "",
				display_name: "",
				mccmnc: "",
				flags: {
					httpota: false,
					smsota: false,
					force_smsota: false,
				},
				technology: "",
				vendor: "none",
				iccids: [],
				files: [
					{
						name: "",
						changed: "0",
					},
				],
				type: "carriers",
				method: "",
			},
		};
	},
	computed: {
		submitDisabled() {
			return this.displayNameState !== false && this.findChange && this.parentState !== false;
		},

		parentState() {
			if (this.carrierUpdate.parent === this.carrier.parent) {
				return null;
			} else if (this.carrierUpdate.parent !== undefined && this.carrierUpdate.parent !== "") {
				return true;
			} else {
				return false;
			}
		},

		technologyState() {
			// console.log(this.carrierUpdate.technology);
			if (this.carrierUpdate.technology === this.carrier.technology && this.carrierUpdate.technology !== "") {
				return null;
			} else if (this.carrierUpdate.technology !== undefined && this.carrierUpdate.technology !== "") {
				return true;
			} else {
				return false;
			}
		},

		vendorState() {
			// console.log(this.carrierUpdate.vendor);
			if (this.carrierUpdate.vendor === this.carrier.vendor) {
				return null;
			} else if (this.carrierUpdate.vendor !== undefined && this.carrierUpdate.vendor !== "") {
				return true;
			} else {
				return false;
			}
		},

		findChange() {
			if (this.carrierUpdate.parent !== this.carrier.parent) {
				return true;
			} else if (this.carrierUpdate.display_name !== this.carrier.display_name) {
				return true;
			} else if (this.carrierUpdate.flags.httpota !== this.carrier.flags.httpota) {
				return true;
			} else if (this.carrierUpdate.flags.smsota !== this.carrier.flags.smsota) {
				return true;
			} else if (this.carrierUpdate.flags.force_smsota !== this.carrier.flags.force_smsota) {
				return true;
			} else if (this.carrierUpdate.technology !== this.carrier.technology) {
				return true;
			} else if (this.carrierUpdate.vendor !== this.carrier.vendor) {
				return true;
			} else if (this.carrierUpdate.mccmnc !== this.carrier.mccmnc) {
				return true;
			} else {
				return false;
			}
		},

		displayNameState() {
			if (this.carrier.display_name === this.carrierUpdate.display_name && this.carrierUpdate.name !== "") {
				return null;
			} else if (
				this.carrierUpdate.display_name !== undefined &&
				this.carrierUpdate.display_name.match("^[a-zA-Z0-9]")
			) {
				return true;
			} else {
				return false;
			}
		},
    mccMncState() {
      if (this.carrier.mccmnc === this.carrierUpdate.mccmnc && this.carrierUpdate.mccmnc !== "") {
        return null;
      } else if (
        this.carrierUpdate.mccmnc !== undefined &&
        this.carrierUpdate.mccmnc.match("^[0-9]{6}$")
      ) {
        return true;
      } else {
        return false;
      }
    },
		isAdministrator() {
			return this.$store.getters["auth/isAdministrator"];
		},
	},
	methods: {
		saveSettings(carrier) {
			if (carrier.name === "") {
				this.carrierUpdate.name = this.carrierUpdate.display_name.toLowerCase().replaceAll(" ", "_");
				// console.log("Current ", this.carrier);
				// console.log("New ", this.carrierUpdate);
				this.addCarrier_API();
			} else {
				this.saveCarrier_API();
			}
		},

		addCarrier_API() {
			const payload = structuredClone(this.carrierUpdate);
			otaDashboardService
				.addCarrier(payload)
				.then(res => {
					if (res && res.data.status) {
						this.$toast.success({
							component: Toast,
							props: {
								subtitle: "PASS:",
								description: "Carrier setup successful, the new carrier is now available to add ICCID ranges and upload files.",
							},
						});
						this.$root.$emit("getCarrierList_API");
					} else {
						this.$toast.error({
							component: Toast,
							props: {
								subtitle: "ERROR:",
								description: res.data.error_string,
							},
						});
					}
				})
				.catch(err => {
					this.$toast.error({
						component: Toast,
						props: {
							subtitle: "ERROR:",
							description: err.message,
						},
					});
				});
		},
		async saveCarrier_API() {
			const sendData = structuredClone(this.carrierUpdate);

			await otaDashboardService
				.saveCarrier(sendData)
				.then(res => {
					if (res && res.data.status) {
						this.$toast.success({
							component: Toast,
							props: {
								subtitle: "PASS:",
								description: "Carrier settings update successful.",
							},
						});
						this.$root.$emit("getCarrierList_API");
					} else {
						this.$toast.error({
							component: Toast,
							props: {
								subtitle: "ERROR:",
								description: res.data.error_string,
							},
						});
					}
				})
				.catch(err => {
					console.log("ERROR", err);
					this.$toast.error({
						component: Toast,
						props: {
							subtitle: "ERROR:",
							description: err.message,
						},
					});
				});
		},
	},
};
</script>
